(function(doc, win) {
  var docEl = doc.documentElement;
  var resizeEvt =
    'orientationchange' in window ? 'orientationchange' : 'resize';
  var recalc = function() {
    if (window.__setFontSize__ == 'disable') {
      return;
    }
    docEl.style.fontSize =
      (document.documentElement.clientWidth / 7.5) * 2 + 'px';
  };
  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener('DOMContentLoaded', recalc, false);
})(document, window);
